// extracted by mini-css-extract-plugin
export default {"consultationDateBox":"ConsultationDateBox_consultationDateBox__GQDZH","consultationDateBoxActive":"ConsultationDateBox_consultationDateBoxActive__hF3Xp"};